import type { ShortcutItem, ShortcutMap, ShortcutNamesapce } from '../type';

const resolveShortcutMap = <
  NS extends Dictionary<string>,
  CMD extends Dictionary<string>,
>(
  defaultShortcut: ShortcutMap<NS, CMD>,
  loadedShortcut: Nullish<ShortcutMap<NS, CMD>>,
) => {
  /* v8 ignore next -- @preserve */
  if (!loadedShortcut) return defaultShortcut;

  const namespaceList = Object.keys(defaultShortcut) as ShortcutNamesapce<NS>[];

  namespaceList.forEach(ns => {
    const defaultShortcutCommandMap = new Map<string, ShortcutItem<CMD>>();

    defaultShortcut[ns].forEach(v => {
      defaultShortcutCommandMap.set(v.command, v);
    });

    const loadedShortcutList = loadedShortcut[ns] ?? [];

    /* v8 ignore next -- @preserve */
    loadedShortcut[ns] = loadedShortcutList
      .filter(loadedItem => defaultShortcutCommandMap.has(loadedItem.command))
      .map(loadedItem => {
        const defaultShortcutItem = defaultShortcutCommandMap.get(
          loadedItem.command,
        );

        if (defaultShortcutItem) {
          return {
            ...defaultShortcutItem,
            key: loadedItem.key ?? defaultShortcutItem.key,
            inactivated:
              loadedItem.inactivated ?? defaultShortcutItem.inactivated,
          };
        }

        /* v8 ignore next -- @preserve */
        return loadedItem;
      });
  });

  return loadedShortcut;
};

export default resolveShortcutMap;
